<template>
  <el-dialog :title="$t('EXCELImportText')" :visible.sync="dialogVisible" width="600px" :before-close="hide" destroy-on-close>
    <div class="text">
      <slot></slot>
    </div>
    <div>
      <BjImportFile ref="BjImportFile" accept=".xls,.xlsx" :limit-size="128 * 1024" auto-upload @importFile="importFile">
        <template #top> </template>
        <template slot="default"> {{ $t('UploadFileSizeText') }} </template>
      </BjImportFile>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="confirm">{{ $t('ConfirmImportText') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { commonApi, importApi } from '@/api';
import { downloadBlob } from '@/utils/index';
export default {
  name: 'BjExcelImportDialog',
  props: {
    title: {
      type: String,
      default: '导入',
    },
    href: {
      type: String,
      default: null,
    },
    downloadName: {
      type: String,
      default: 'demo',
    },
    // 默认供应商
    prefix: {
      type: String,
      default: 'sgoo',
    },
    templateCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialogVisible: false,
      file: null,
    };
  },
  methods: {
    show() {
      this.file = null;
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    onDownload() {
      const data = {templateCode: this.templateCode, tenantId: 0};
      importApi['exportExcelImportTemplateHeaders'](data).then(res => {
        downloadBlob(res, `${this.downloadName}.xlsx`);
      });
    },
    importFile(file) {
      this.file = file;
    },
    confirm() {
      if (!this.templateCode) {
        this.$message.error(`${this.$t('TemplatedMsgText')}：templateCode`);
        return;
      }
      commonApi
        .autoImport({
          prefix: this.prefix,
          excel: this.file,
          templateCode: this.templateCode,
        })
        .then(res => {
          this.$message({
            message: this.$t('UploadMsgText'),
            type: 'success',
            duration: 5000,
          });
          this.hide();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.text {
  font-size: 12px;
  line-height: 2;
}
</style>
